var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (query) {
buf.push("<div class=\"tt-suggestion is-empty\"><span class=\"typeahead-suggestion-name\">Sorry, &ldquo;" + (jade.escape((jade_interp = query) == null ? '' : jade_interp)) + "&rdquo; not found</span></div>");}.call(this,"query" in locals_for_with?locals_for_with.query:typeof query!=="undefined"?query:undefined));;return buf.join("");
};
module.exports = template;